import { HStack, Stack, Text } from "@chakra-ui/react";
import DataSourceModal from "./DataSourceModal";
import SVGIcon from "./SVGIcon";

const InstallerServices = (installer) => {
  const services = [
    {
      name: "Solar PV",
      key: "technology_solarpv",
      file: "/sun.svg",
    },
    {
      name: "Air Source Heat Pump",
      key: "technology_ashp",
      file: "/heat.svg",
    },
    { name: "Biomass", key: "technology_biomass", file: "/fire.svg" },
    {
      name: "Exhaust Air Heat Pump",
      key: "technology_eahp",
      file: "/heat.svg",
    },
    { name: "Ground Air Heat Pump", key: "technology_gahp", file: "/heat.svg" },
    {
      name: "Ground Source Heat Pump",
      key: "technology_gshp",
      file: "/heat.svg",
    },
    {
      name: "Battery Storage",
      key: "technology_battery",
      file: "/battery.svg",
    },
    { name: "Hydro", key: "technology_hydro", file: "/water.svg" },
    { name: "Micro-CHP", key: "technology_microchp", file: "/fire.svg" },
    {
      name: "Surface Air Heat Pump",
      key: "technology_sahp",
      file: "/heat.svg",
    },
    {
      name: "Solar Thermal",
      key: "technology_solarthermal",
      file: "/heat.svg",
    },
    {
      name: "Wind Turbine",
      key: "technology_windturbine",
      file: "/wind.svg",
    },
    {
      name: "Water Source Heat Pump",
      key: "technology_wshp",
      file: "/heat.svg",
    },
  ];

  // Filter services to only include those that are verified or have alwaysShow set to true
  // Sort the services so that verified services are shown first
  const displayedServices = services
    .filter((tech) => installer[tech.key])
    .sort((a, b) => {
      if (installer[a.key] && installer[b.key]) {
        return 0;
      }
      if (installer[a.key]) {
        return -1;
      }
      return 1;
    });

  return (
    <>
      <Stack direction={["column"]} spacing={0}>
        <HStack mb={2}>
          <Text as={"b"}>Services</Text>
          <DataSourceModal />
        </HStack>
        {displayedServices.map((tech) => (
          <HStack key={tech.key} mr={6}>
            <SVGIcon icon={tech.file} size={5} />
            <Text color={"gray.600"}>{tech.name}</Text>
          </HStack>
        ))}
      </Stack>
    </>
  );
};

export default InstallerServices;
